import Avatar from '@mui/material/Avatar';
import ButtonBase from '@mui/material/ButtonBase';
import styled from '@mui/material/styles/styled';
import PropTypes from 'prop-types';

import { getInitials, formatUserInfo } from '../../../utils/utils';
import UserTooltip from '../../elements/user-tooltip/UserTooltip';

const StyledAvatar = styled(Avatar)(({ theme }) => ({
  fontSize: '0.9rem',
  width: theme.spacing(4) - 2,
  height: theme.spacing(4) - 2,
  margin: 'auto',
  '&:hover': {
    filter: 'brightness(85%)',
  },
}));

const UserAvatar = ({ user }) => {
  const { publicName } = formatUserInfo(user);

  return (
    <UserTooltip user={user}>
      <ButtonBase sx={{ borderRadius: 20 }}>
        <StyledAvatar src={user?.icon} alt={publicName} variant="circle">
          {getInitials(publicName)}
        </StyledAvatar>
      </ButtonBase>
    </UserTooltip>
  );
};

UserAvatar.propTypes = {
  user: PropTypes.object.isRequired,
};

export default UserAvatar;
